import React from 'react';

interface LeagueSelectorProps {
  value: string;
  onChange: (league: string) => void;
}

export const LeagueSelector: React.FC<LeagueSelectorProps> = ({ value, onChange }) => {
  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    onChange(e.target.value);
  };

  return (
    <div>
      <label htmlFor="league-select" className="block text-sm text-gray-400 mb-1">
        League:
      </label>
      <select
        id="league-select"
        value={value}
        onChange={handleChange}
        className="bg-gray-700 text-white rounded px-3 py-2 border border-gray-600 focus:border-blue-500 focus:outline-none"
      >
        <option value="Phrecia">Phrecia</option>
        <option value="Hardcore Phrecia">Hardcore Phrecia</option>
        <option value="SSF Phrecia">SSF Phrecia</option>
        <option value="HC SSF Phrecia">HC SSF Phrecia</option>
        <option value="Ruthless Phrecia">Ruthless Phrecia</option>
        <option value="HC Ruthless Phrecia">HC Ruthless Phrecia</option>
      </select>
    </div>
  );
};

export default LeagueSelector;